const MOBILE_PRIORITY_COLLECTION = "talmidsdb/communityPlanning/priorities";
const DEFAULT_PRIORITY_COLLECTION = "talmidsdb/priorities";

export function normalizePriorityRecord(item = {}) {
	return {
		...item,
		id: item.id || item.priorityID || "",
		priorityID: item.priorityID || item.id || "",
		communityID: item.communityID || item.communityId || "",
		initiativeID: item.initiativeID || item.initiativeId || "",
		organisationID: item.organisationID || item.orgID || item.orgId || "",
		priority: item.priority ?? item.priorityLevel ?? "",
		priorityName: item.priorityName || item.contribution || item.comments || "",
		startDate: item.startDate || "",
		endDate: item.endDate || item.targetEndDate || "",
		responsibleUserID: item.responsibleUserID || item.responsiblePerson || "",
		_sourceCollection: item._sourceCollection || DEFAULT_PRIORITY_COLLECTION,
	};
}

export function getPriorityEndpoint(item = {}) {
	return String(item._sourceCollection || DEFAULT_PRIORITY_COLLECTION)
		.replace(/^\/+/, "")
		.replace(/^talmidsdb\//, "");
}

export function serializePriorityForSource(values, item = {}) {
	if (item._sourceCollection !== MOBILE_PRIORITY_COLLECTION) {
		return values;
	}

	const numericPriority = Number(values.priority);
	return {
		communityId: values.communityID || "",
		initiativeId: values.initiativeID || "",
		orgId: values.organisationID || "",
		priorityLevel: Number.isFinite(numericPriority) ? numericPriority : values.priority,
		startDate: values.startDate || "",
		targetEndDate: values.endDate || "",
		responsiblePerson: values.responsibleUserID || "",
		updatedAt: Date.now(),
	};
}

export { MOBILE_PRIORITY_COLLECTION };
